import React from "react";
import { useTranslation } from "react-i18next";

import { IconFlight2, IconHotel2, IconHomeFill, IconOrder } from "../icons";

interface Props {}

const MenuSso: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className="header-sso">
      <div
        className="container mx-auto"
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          height: "100%",
        }}
      >
        <a
          className="menu-item-sso"
          href={process.env.REACT_APP_URL_ATADI_COM + "/"}
        >
          <IconHomeFill />
          &nbsp;&nbsp;
          <span>{t("Trang chủ")}</span>
        </a>

        <a
          className="menu-item-sso"
          href={process.env.REACT_APP_URL_ATADI_COM + "/ve-may-bay"}
        >
          <IconFlight2 />
          &nbsp;&nbsp;
          <span>{t("Vé máy bay")}</span>
        </a>

        <a
          className="menu-item-sso"
          href={process.env.REACT_APP_URL_ATADI_COM + "/khach-san"}
        >
          <IconHotel2 />
          &nbsp;&nbsp;
          <span>{t("Khách sạn")}</span>
        </a>

        <a
          className="menu-item-sso"
          href={process.env.REACT_APP_URL_ATADI_COM + "/tai-khoan/chuyen-bay"}
        >
          <IconOrder />
          &nbsp;&nbsp;
          <span>{t("Đơn hàng")}</span>
        </a>
      </div>
    </div>
  );
};

export default MenuSso;
